var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66668 4.5293C7.98851 4.63942 6.37762 5.23084 5.02685 6.23275C3.67609 7.23467 2.64268 8.60463 2.05033 10.1786C1.45798 11.7527 1.33179 13.464 1.68687 15.1079C2.04194 16.7518 2.86324 18.2585 4.05244 19.4477C5.24164 20.6369 6.74836 21.4582 8.39224 21.8133C10.0361 22.1684 11.7475 22.0422 13.3215 21.4498C14.8955 20.8575 16.2655 19.8241 17.2674 18.4733C18.2693 17.1225 18.8607 15.5116 18.9708 13.8335H9.66668V4.5293Z",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1C13.5529 1 13.3604 1.01633 13.1667 1.02917V10.3333H22.4709C22.4837 10.1397 22.5 9.94717 22.5 9.75C22.5 7.42936 21.5781 5.20376 19.9372 3.56282C18.2963 1.92187 16.0707 1 13.75 1Z",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.1dc16a9d75c6f637390b340e6a51f850.svg";
export { ForwardRef as ReactComponent };